import React from 'react';
import SecuredZone from '../SecuredZone/SecuredZone';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Component } from 'react';
import RichTextEditor from '../../../components/RichTextEditor/RichTextEditor';
import { convertHtmlToEditorJS, convertEditorJSToHtml } from '../../../utils/editorConverter';
import ImageUpload from '../../../components/ImageUpload/ImageUpload';
import TextField from '@material-ui/core/TextField';
import API from '../../../api/api';
import uuid from "uuid";
import OpeningHours from "../../../components/OpeningHours/OpeningHours";
import { 
  Paper, 
  Box, 
  Typography, 
  Grid,
  Divider,
  Button
} from '@material-ui/core';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import HomeIcon from '@material-ui/icons/Home';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import FooterIcon from '@material-ui/icons/Description';
import EventIcon from '@material-ui/icons/Event';
import BusinessIcon from '@material-ui/icons/Business';
import InfoIcon from '@material-ui/icons/Info';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import SaveIcon from '@material-ui/icons/Save';

const garageApi = new API();

class AdminSite extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      loadingDialog: false,
      update: true,
      originalImages: {}, // Speichere ursprüngliche Bild-IDs
      web: {
        unikey: uuid.v4(),
        homeWelcomeTitle: 'Wilkommen',
        homeWelcomeText: 'Text',
        contactText:'Text',
        footerText:'Text',
        partnerText:'Text',
        garageLocation:'0,0',
        appointmentSuggestionText:'Text',
        appointmentSummaryText:'Text',
        appointmentThanksText:'Text',
        garageAboutText:'Text',
        impressumText:'Text',
        mapsLink:'Text',
        mapsLinkText:'Text',
        popUpcontactText:'Text',
        dataProtectionText:'Text',
        homeWriter:'Hello,World',
        heroVideoUrl:'/videos/hero-drone.mp4',
        homeImage:null,
        servicesImage:null,
        galleryImage:null,
        appointmentImage:null,
        dataProtectionImage:null,
        impressumImage:null,
        openingHours: {}
      },
    };

    this.days = [
        { key: "mon", name: "Montag" },
        { key: "tue", name: "Dienstag" },
        { key: "wed", name: "Mittwoch" },
        { key: "thu", name: "Donnerstag" },
        { key: "fri", name: "Freitag" },
        { key: "sat", name: "Samstag" },
        { key: "sun", name: "Sonntag" }
      ];

    this.fieldName = "location[working_hours]";
  }

  componentDidMount() {
    this.getConfig();
  }

  updateSelect(key, values) {
    this.setState(prevState => {
      const currentValues = prevState.web.openingHours[key];
      
      // Check if values actually changed
      const hasChanged = !currentValues || 
        currentValues.length !== values.length ||
        currentValues.some((val, index) => {
          if (!values[index]) return true;
          return val[0] !== values[index][0] || val[1] !== values[index][1];
        });
      
      if (!hasChanged) {
        return null; // No state update needed
      }
      
      return {
        web: {
          ...prevState.web,
          openingHours: {
            ...prevState.web.openingHours,
            [key]: values
          }
        }
      };
    });
  }

  getConfig(create = true)
  {
    garageApi.endpoints.site.getAll()
      .then((getRequest) => {
        try
        {
          // API returns object directly, not array with results
          const webData = getRequest.data;
          
          if(!webData || Object.keys(webData).length === 0)
          {
            if(create) {
              this.createConfig();
            }
            else {
              console.log('error: No site configuration found');
            }
          } else {

            // Parse openingHours if it's a string
            try {
              if (typeof webData.openingHours === 'string') {
                webData.openingHours = JSON.parse(webData.openingHours);
              } else if (!webData.openingHours) {
                webData.openingHours = {};
              }
              // Convert array to object format if needed
              if (Array.isArray(webData.openingHours)) {
                webData.openingHours = {};
              }
            } catch (e)
            {
              // openingHours might not be valid JSON, keep as is or set to empty object
              webData.openingHours = webData.openingHours || {};
            }

            // Convert HTML text fields to EditorJS format
            const processedData = { ...webData };
            
            const textFields = [
              'homeWelcomeText', 'contactText', 'footerText', 'partnerText',
              'appointmentSuggestionText', 'appointmentSummaryText', 'appointmentThanksText',
              'garageAboutText', 'mapsLinkText', 'popUpcontactText', 'impressumText', 'dataProtectionText'
            ];
            
            textFields.forEach(field => {
              if (processedData[field] && typeof processedData[field] === 'string') {
                processedData[field] = convertHtmlToEditorJS(processedData[field]);
              }
            });

            console.log('Loaded site config with ID:', processedData.id);
            
            // Speichere ursprüngliche Bild-IDs
            const imageKeys = ['homeImage', 'servicesImage', 'galleryImage', 'appointmentImage', 'impressumImage', 'dataProtectionImage'];
            const originalImages = {};
            imageKeys.forEach(key => {
              if (processedData[key]) {
                // Wenn es ein Objekt ist, extrahiere die ID
                if (typeof processedData[key] === 'object' && processedData[key].id) {
                  originalImages[key] = processedData[key].id;
                } else if (typeof processedData[key] === 'number') {
                  originalImages[key] = processedData[key];
                }
              }
            });
            
            this.setState({ 
              web: processedData,
              originalImages: originalImages
            });
            this.setState({ loading: false });
          }

        }
        catch(e)
        {
          console.log('error loading config:', e);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        console.error('Error loading site config:', error);
        this.setState({ loading: false });
      });
  }

  createConfig()
  {
    garageApi.endpoints.site.create(this.state.web)
      .then((getRequest) => {
        // Update state with the created config including ID
        if (getRequest.data && getRequest.data.id) {
          this.setState({ 
            web: { ...this.state.web, id: getRequest.data.id }
          });
        }
        this.getConfig(false);
      })
      .catch((error) => {
        console.error('Error creating config:', error);
      });
  }

  saveConfig()
  {
    // Convert EditorJS data to HTML before saving
    const webData = { ...this.state.web };
    
    // Remove ID if present (not needed for site update)
    delete webData.id;
    
    // Convert openingHours to JSON string if it's an object
    if (webData.openingHours && typeof webData.openingHours === 'object') {
      webData.openingHours = JSON.stringify(webData.openingHours);
    }
    
    const textFields = [
      'homeWelcomeText', 'contactText', 'footerText', 'partnerText',
      'appointmentSuggestionText', 'appointmentSummaryText', 'appointmentThanksText',
      'garageAboutText', 'mapsLinkText', 'popUpcontactText', 'impressumText', 'dataProtectionText'
    ];
    
    textFields.forEach(field => {
      if (webData[field] && typeof webData[field] === 'object') {
        webData[field] = convertEditorJSToHtml(webData[field]);
      }
    });

    // Nur Bildfelder senden, wenn sie geändert wurden (neue ID gesetzt wurde)
    const imageKeys = ['homeImage', 'servicesImage', 'galleryImage', 'appointmentImage', 'impressumImage', 'dataProtectionImage'];
    imageKeys.forEach(key => {
      const currentValue = webData[key];
      const originalId = this.state.originalImages[key];
      
      // Wenn das Bild nicht geändert wurde (gleiche ID oder noch ein Objekt), entferne es aus webData
      if (currentValue && typeof currentValue === 'object' && currentValue.id) {
        // Wenn es noch ein Objekt ist und die ID gleich der ursprünglichen ist, entferne es
        if (currentValue.id === originalId) {
          delete webData[key];
        } else {
          // Neue ID wurde gesetzt, sende nur die ID
          webData[key] = currentValue.id;
        }
      } else if (typeof currentValue === 'number' && currentValue === originalId) {
        // Wenn es eine Zahl ist und gleich der ursprünglichen ID, entferne es
        delete webData[key];
      } else if (!currentValue || currentValue === null) {
        // Wenn es null ist, entferne es (nicht senden)
        delete webData[key];
      }
      // Wenn currentValue eine neue Zahl ist (ungleich originalId), wird sie gesendet
    });

    garageApi.endpoints.site.update(webData)
      .then((getRequest) => {
        try
        {
          console.log('saved');
          // Reload config to get fresh data
          this.getConfig(false);
        }
        catch(e)
        {
          console.log(e);
        }
      })
      .catch((error) => {
        console.error('Error saving config:', error);
      });
  }

  updateText(fieldName, editorData)
  { 
    // Store EditorJS data format
    this.setState(prevState => ({
      web: {
        ...prevState.web,
        [fieldName]: editorData
      },
      update: true
    }));
  }

  handleImageUpload = (imageKey) => (uploadData) => {
    this.setState((prevState) => ({
      web: {
        ...prevState.web,
        [imageKey]:
          !uploadData || uploadData.cleared || !uploadData.id
            ? null
            : uploadData,
      },
    }));
  }

  handleImageUploadError = () => {}

  render() {
    const { loading, web } = this.state;

    return (
      <SecuredZone
        breadcrumbs={{ '/admin/': 'Dashboard','/admin/site': 'Allgemein' }}
        title="Allgemein"
        loading={loading ? <LinearProgress color="primary" /> : <span className="loader-span"></span>}
      >
        
        {!loading && (
          <Box style={{ padding: '20px' }}>
            {/* Save Button */}
            <Box display="flex" justifyContent="flex-end" marginBottom="24px">
              <Button
                variant="contained"
                color="primary"
                size="large"
                startIcon={<SaveIcon />}
                onClick={this.saveConfig.bind(this)}
                style={{ padding: '10px 24px' }}
              >
                Speichern
              </Button>
            </Box>

            {/* Öffnungszeiten */}
            <Paper elevation={2} style={{ padding: '24px', marginBottom: '24px' }}>
              <Box display="flex" alignItems="center" marginBottom="20px">
                <AccessTimeIcon style={{ fontSize: 32, color: '#1976d2', marginRight: '12px' }} />
                <Typography variant="h5" style={{ fontWeight: 600 }}>
                  Öffnungszeiten
                </Typography>
              </Box>
              <Divider style={{ marginBottom: '20px' }} />
              <OpeningHours 
                updateSelect={this.updateSelect.bind(this)} 
                days={this.days} 
                fieldName={this.fieldName} 
                data={web.openingHours} 
              />
            </Paper>

            {/* Startseite */}
            <Paper elevation={2} style={{ padding: '24px', marginBottom: '24px' }}>
              <Box display="flex" alignItems="center" marginBottom="20px">
                <HomeIcon style={{ fontSize: 32, color: '#f57c00', marginRight: '12px' }} />
                <Typography variant="h5" style={{ fontWeight: 600 }}>
                  Startseite
                </Typography>
              </Box>
              <Divider style={{ marginBottom: '20px' }} />
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
            <TextField
                    fullWidth
                    margin="normal"
              id="homeWelcomeTitle"
              label="Titel"
              variant="outlined"
                    value={web.homeWelcomeTitle || ''}
                    onChange={(e) => {
                      this.setState(prevState => ({
                        web: {
                          ...prevState.web,
                          homeWelcomeTitle: e.target.value
                        }
                      }));
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
            <TextField
              fullWidth
                    margin="normal"
                    id="homeWriter"
                    label="Home Writer"
              variant="outlined"
                    value={web.homeWriter || ''}
                    onChange={(e) => {
                      this.setState(prevState => ({
                        web: {
                          ...prevState.web,
                          homeWriter: e.target.value
                        }
                      }));
                    }}
                    helperText="Komma-getrennte Werte (z.B. Hello,World)"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    margin="normal"
                    id="heroVideoUrl"
                    label="Drohnenvideo URL"
                    variant="outlined"
                    value={web.heroVideoUrl || ''}
                    onChange={(e) => {
                      this.setState(prevState => ({
                        web: {
                          ...prevState.web,
                          heroVideoUrl: e.target.value
                        }
                      }));
                    }}
                    helperText="Lokal: /videos/hero-drone.mp4 oder eine MP4-URL"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '8px', marginTop: '8px' }}>
                    Startseite Text
                  </Typography>
                  <RichTextEditor 
                    data={web.homeWelcomeText} 
                    onChange={(data) => this.updateText('homeWelcomeText', data)}
                    placeholder="Startseite Text eingeben..."
                  />
                </Grid>
              </Grid>
            </Paper>

            {/* Standort */}
            <Paper elevation={2} style={{ padding: '24px', marginBottom: '24px' }}>
              <Box display="flex" alignItems="center" marginBottom="20px">
                <LocationOnIcon style={{ fontSize: 32, color: '#d32f2f', marginRight: '12px' }} />
                <Typography variant="h5" style={{ fontWeight: 600 }}>
                  Standort
                </Typography>
              </Box>
              <Divider style={{ marginBottom: '20px' }} />
              <TextField
                fullWidth
                margin="normal"
                id="garageLocation"
                label="Standort (Koordinaten)"
                variant="outlined"
                value={web.garageLocation || ''}
                onChange={(e) => {
                  this.setState(prevState => ({
                    web: {
                      ...prevState.web,
                      garageLocation: e.target.value
                    }
                  }));
                }}
                helperText="Format: Längengrad,Breitengrad (z.B. 8.5417,47.3769)"
              />
            </Paper>

            {/* Kontakt */}
            <Paper elevation={2} style={{ padding: '24px', marginBottom: '24px' }}>
              <Box display="flex" alignItems="center" marginBottom="20px">
                <ContactMailIcon style={{ fontSize: 32, color: '#0288d1', marginRight: '12px' }} />
                <Typography variant="h5" style={{ fontWeight: 600 }}>
                  Kontakt
                </Typography>
              </Box>
              <Divider style={{ marginBottom: '20px' }} />
              <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '8px' }}>
                Kontakt Text
              </Typography>
              <RichTextEditor 
                data={web.contactText} 
                onChange={(data) => this.updateText('contactText', data)}
                placeholder="Kontakt Text eingeben..."
              />
            </Paper>

            {/* Footer */}
            <Paper elevation={2} style={{ padding: '24px', marginBottom: '24px' }}>
              <Box display="flex" alignItems="center" marginBottom="20px">
                <FooterIcon style={{ fontSize: 32, color: '#7b1fa2', marginRight: '12px' }} />
                <Typography variant="h5" style={{ fontWeight: 600 }}>
                  Footer
                </Typography>
              </Box>
              <Divider style={{ marginBottom: '20px' }} />
              <Box marginBottom="24px">
                <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '8px' }}>
                  Footer Text
                </Typography>
                <RichTextEditor 
                  data={web.footerText} 
                  onChange={(data) => this.updateText('footerText', data)}
                  placeholder="Footer Text eingeben..."
                />
              </Box>
              <Box>
                <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '8px' }}>
                  Partner Text
                </Typography>
                <RichTextEditor 
                  data={web.partnerText} 
                  onChange={(data) => this.updateText('partnerText', data)}
                  placeholder="Partner Text eingeben..."
                />
              </Box>
            </Paper>

            {/* Online Termin */}
            <Paper elevation={2} style={{ padding: '24px', marginBottom: '24px' }}>
              <Box display="flex" alignItems="center" marginBottom="20px">
                <EventIcon style={{ fontSize: 32, color: '#388e3c', marginRight: '12px' }} />
                <Typography variant="h5" style={{ fontWeight: 600 }}>
                  Online Termin
                </Typography>
              </Box>
              <Divider style={{ marginBottom: '20px' }} />
              <Box marginBottom="24px">
                <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '8px' }}>
                  Termin Zeit Vorschlags Text
                </Typography>
                <RichTextEditor 
                  data={web.appointmentSuggestionText} 
                  onChange={(data) => this.updateText('appointmentSuggestionText', data)}
                  placeholder="Termin Zeit Vorschlags Text eingeben..."
                />
              </Box>
              <Box marginBottom="24px">
                <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '8px' }}>
                  Zusammenfassungs Text
                </Typography>
                <RichTextEditor 
                  data={web.appointmentSummaryText} 
                  onChange={(data) => this.updateText('appointmentSummaryText', data)}
                  placeholder="Zusammenfassungs Text eingeben..."
                />
              </Box>
              <Box>
                <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '8px' }}>
                  Dankes Text
                </Typography>
                <RichTextEditor 
                  data={web.appointmentThanksText} 
                  onChange={(data) => this.updateText('appointmentThanksText', data)}
                  placeholder="Dankes Text eingeben..."
                />
              </Box>
            </Paper>

            {/* Garage */}
            <Paper elevation={2} style={{ padding: '24px', marginBottom: '24px' }}>
              <Box display="flex" alignItems="center" marginBottom="20px">
                <BusinessIcon style={{ fontSize: 32, color: '#f57c00', marginRight: '12px' }} />
                <Typography variant="h5" style={{ fontWeight: 600 }}>
                  Garage
                </Typography>
              </Box>
              <Divider style={{ marginBottom: '20px' }} />
              <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '8px' }}>
                Über uns Text
              </Typography>
              <RichTextEditor 
                data={web.garageAboutText} 
                onChange={(data) => this.updateText('garageAboutText', data)}
                placeholder="Über uns Text eingeben..."
              />
            </Paper>

            {/* PopUp Box */}
            <Paper elevation={2} style={{ padding: '24px', marginBottom: '24px' }}>
              <Box display="flex" alignItems="center" marginBottom="20px">
                <InfoIcon style={{ fontSize: 32, color: '#0288d1', marginRight: '12px' }} />
                <Typography variant="h5" style={{ fontWeight: 600 }}>
                  PopUp Box
                </Typography>
              </Box>
              <Divider style={{ marginBottom: '20px' }} />
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    margin="normal"
                    id="mapsLink"
                    label="Karten Link"
                    variant="outlined"
                    value={web.mapsLink || ''}
                    onChange={(e) => {
                      this.setState(prevState => ({
                        web: {
                          ...prevState.web,
                          mapsLink: e.target.value
                        }
                      }));
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '8px' }}>
                    Karten Text
                  </Typography>
                  <RichTextEditor 
                    data={web.mapsLinkText} 
                    onChange={(data) => this.updateText('mapsLinkText', data)}
                    placeholder="Karten Text eingeben..."
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '8px' }}>
                    Kontakt Text
                  </Typography>
                  <RichTextEditor 
                    data={web.popUpcontactText} 
                    onChange={(data) => this.updateText('popUpcontactText', data)}
                    placeholder="Kontakt Text eingeben..."
                  />
                </Grid>
              </Grid>
            </Paper>

            {/* Impressum & Datenschutz */}
            <Grid container spacing={3} style={{ marginBottom: '24px' }}>
              <Grid item xs={12} md={6}>
                <Paper elevation={2} style={{ padding: '24px', minHeight: '400px', display: 'flex', flexDirection: 'column' }}>
                  <Box display="flex" alignItems="center" marginBottom="20px" style={{ flexShrink: 0 }}>
                    <InfoIcon style={{ fontSize: 32, color: '#7b1fa2', marginRight: '12px' }} />
                    <Typography variant="h5" style={{ fontWeight: 600 }}>
                      Impressum
                    </Typography>
                  </Box>
                  <Divider style={{ marginBottom: '20px', flexShrink: 0 }} />
                  <Box style={{ flex: 1, minHeight: 0 }}>
                    <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '8px' }}>
                      Impressum Text
                    </Typography>
                    <RichTextEditor 
                      data={web.impressumText} 
                      onChange={(data) => this.updateText('impressumText', data)}
                      placeholder="Impressum Text eingeben..."
                    />
                  </Box>
                </Paper>
              </Grid>
              <Grid item xs={12} md={6}>
                <Paper elevation={2} style={{ padding: '24px', minHeight: '400px', display: 'flex', flexDirection: 'column' }}>
                  <Box display="flex" alignItems="center" marginBottom="20px" style={{ flexShrink: 0 }}>
                    <InfoIcon style={{ fontSize: 32, color: '#d32f2f', marginRight: '12px' }} />
                    <Typography variant="h5" style={{ fontWeight: 600 }}>
                      Datenschutz
                    </Typography>
                  </Box>
                  <Divider style={{ marginBottom: '20px', flexShrink: 0 }} />
                  <Box style={{ flex: 1, minHeight: 0 }}>
                    <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '8px' }}>
                      Datenschutz Text
                    </Typography>
                    <RichTextEditor 
                      data={web.dataProtectionText} 
                      onChange={(data) => this.updateText('dataProtectionText', data)}
                      placeholder="Datenschutz Text eingeben..."
                    />
                  </Box>
                </Paper>
              </Grid>
            </Grid>

            {/* Bilder */}
            <Paper elevation={2} style={{ padding: '24px' }}>
              <Box display="flex" alignItems="center" marginBottom="20px">
                <PhotoCameraIcon style={{ fontSize: 32, color: '#f57c00', marginRight: '12px' }} />
                <Typography variant="h5" style={{ fontWeight: 600 }}>
                  Bilder
                </Typography>
              </Box>
              <Divider style={{ marginBottom: '20px' }} />
              <Grid container spacing={3}>
                {[
                  { key: 'homeImage', label: 'Startseite' },
                  { key: 'servicesImage', label: 'Dienstleistungen' },
                  { key: 'galleryImage', label: 'Galerie' },
                  { key: 'appointmentImage', label: 'Online Termin' },
                  { key: 'impressumImage', label: 'Impressum' },
                  { key: 'dataProtectionImage', label: 'Datenschutz' }
                ].map(({ key, label }) => {
                  // Get current image - could be an ID or an object
                  const currentImage = this.state.web[key];
                  const imageObject = currentImage && typeof currentImage === 'object' ? currentImage : null;
                  
                  return (
                    <Grid item xs={12} sm={6} md={4} key={key}>
                      <Box>
                        <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: '8px' }}>
                          {label}
                        </Typography>
                        <ImageUpload
                          type="web"
                          name={label}
                          label={`${label}: Bild hierher ziehen oder klicken`}
                          onUploadComplete={this.handleImageUpload(key)}
                          onUploadError={this.handleImageUploadError}
                          currentImage={imageObject}
                          maxSizeMB={64}
                        />
                      </Box>
                    </Grid>
                  );
                })}
              </Grid>
            </Paper>
          </Box>
        )}
      </SecuredZone>
    );
  }
}

export default AdminSite;
